import * as React from 'react';
import { SVGProps } from 'react';

const IconGasSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 0a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H8v3H7c-1.105 0-2 .897-2 2.002v12.496c0 .933.638 1.718 1.502 1.94L6.5 22.5v.5a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-.5c0-.021 0-.042-.002-.063A2.003 2.003 0 0 0 19 20.498V8.002A2.002 2.002 0 0 0 17 6h-1V3h.5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-9zM13 3v3h-2V3h2zm1 15.63c0 .037-.001.074-.004.11A2.993 2.993 0 0 0 15 16.5c0-.75-.375-1.313-.75-1.875-.375-.563-.75-1.125-.75-1.875a10.77 10.77 0 0 0-1.424 1.12A4.62 4.62 0 0 1 12 11.25c-1.5.75-3 3-3 5.25 0 1.401.96 2.578 2.259 2.908A1.226 1.226 0 0 1 11 18.63c0-.298.27-.63.582-1.013.422-.518.918-1.128.918-1.867 1.5 1.5 1.5 2.413 1.5 2.88z"
    />
  </svg>
);
export default IconGasSizeM;
